<template>
  <div class="container">
    <Modal
      width="600"
      v-model="showModal"
      :footer-hide="true"
      @on-cancel="clear"
      title="审核进度"
    >
    <div v-if="!progressList.length" style="position:relative;min-height:300px">
      <Spin fix></Spin>
    </div>
    <!-- // 0 待审核 1 已通过 2 驳回 -1 已提交 -->
    <Card v-show="errorMsg" style="background:#ed4014;color:#fff;font-weight:blod;font-size:16px;">驳回原因：{{errorMsg}}</Card>
    <div v-for="(item, index) in progressList" style="display:flex;margin-top:10px;" :key="index">
      <Icon v-show="item.status === '1' || item.status === '-1'" type="md-checkmark-circle" :size='30' color="#19be6b" class="icon" />
      <Icon v-show="item.status === '0' || item.status === '-2'" type="ios-loading" :size='30' color="#5cadff" class="icon" />
      <Icon v-show="item.status === '2'" type="md-close-circle" :size='30' color="#ed4014" class="icon" />
      <Card style="width:100%">
        <div class="progress_box">
          <div>{{item.auditUsernames}}</div>
          <div>
            <div class="progress_status">{{`${item.level === 0 ? '' : item.status === '0' || item.status === '-2' ? '': item.auditUsername} ${progressStatus(item.status)}`}}</div>
            <div>{{item.status === '0' ? '' : item.verifyTime || ''}}</div>
          </div>
        </div>
      </Card>
    </div>
    </Modal>
  </div>
</template>

<script>
import https from '../../https'
export default {
  name: 'esApp',
  data () {
    return {
      loading: true,
      tableLoading: true,
      showModal: false,
      progressList: [],
      errorMsg: null,
      url: {
        esPluginVerify: 'extscreenapi/plugin/hili/esPluginVerify/progress',
        esPluginVersionVerify: 'extscreenapi/plugin/hili/esPluginVersionVerify/progress',
        appProgress: 'v2/es/audit/app/progress',
        appver: 'v2/es/audit/appver/progress'
      }
    }
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.token = https.token
  },
  mounted () {
  },
  methods: {
    progressStatus (status) {
      if (status === '0') {
        return '待审核'
      } else if (status === '-1') {
        return '已提交'
      } else if (status === '1') {
        return '已通过'
      } else if (status === '2') {
        return '驳回'
      } else if (status === '-2') {
        return ''
      }
    },
    clear () {
      this.progressList = []
      this.errorMsg = ''
    },
    show (row, type, typeT) {
      this.showModal = true
      let params = {}
      let url = ''
      if (typeT === 'sdk' || typeT === 'apk') {
        params = {
          bigPluginType: type,
          id: row.id
        }
        url = this.url.esPluginVerify
      } else if (typeT === 'sdkVer' || typeT === 'apkVer') {
        params = {
          bigPluginType: type,
          pluginId: row.pluginId,
          id: row.id
        }
        url = this.url.esPluginVersionVerify
      } else if (typeT === 'app') {
        params = {
          pkg_name: row.package_name
        }
        url = this.url.appProgress
      } else if (typeT === 'appVer') {
        params = {
          id: row.id
        }
        url = this.url.appver
      }
      https.request({
        method: 'post',
        url: url,
        headers: {
          'Content-Type': 'application/json',
          'satoken': https.token
        },
        data: params
      }).then(res => {
        // 0 待审核 1 已通过 2 驳回 -1 已提交
        console.log(res)
        let data = null
        if (typeT === 'app' || typeT === 'appVer') {
          data = res.data
        } else {
          data = res.result
        }
        // let entry1 = {
        //   auditUsernames: '一级审核',
        //   auditUsername: '',
        //   verifyTime: '',
        //   status: '0'
        // }
        // let entry2 = {
        //   auditUsernames: '二级审核',
        //   auditUsername: '',
        //   verifyTime: '',
        //   status: '0'
        // }
        data[0].status = '-1'
        data[0].auditUsernames = data[0].auditUsername
        // if (data.length === 1) {
        //   console.log('待审核')
        //   if (data[0].totalLevel === 1) {
        //     this.progressList = [data[0], entry1]
        //   } else {
        //     this.progressList = [data[0], entry1, entry2]
        //   }
        // } else {
        // }
        if (data.length === 2) {
          console.log('一级审核')
          if (data[1].status === '2') {
            this.errorMsg = data[1].reason
          }
          if (data[1].totalLevel === 1) {
            this.progressList = [...data]
          } else {
            this.progressList = [...data]
          }
        } else if (data.length === 3) {
          console.log('二级审核')
          data.map(item => {
            if (item.status === '2') {
              this.errorMsg = item.reason
            }
          })
          this.progressList = data
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .progress_box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height:54px;
  }
  .progress_status{
    width: 150px;
    text-align: center;
  }
  .icon{
    margin-top:30px;
    margin-right:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/global/verifyModal.vue